export default "__VITE_ASSET__0aa228ae__"